<mat-card [appearance]="matCardAppearance()">
  <mat-card-content [formGroup]="searchForm" class="p-2!">
    @if (selectedUiItem(); as selectedItem) {
      <div [ngClass]="matCardAppearance() === 'outlined' ? 'px-3' : 'px-0'">
        <p class="text-sm text-on-surface-variant mb-2 font-medium">
          {{ label() | titlecase }}:
        </p>

        <div
          class="group relative flex items-stretch h-16 border rounded-lg overflow-hidden transition-all duration-200 border-primary ring-1 ring-primary text-on-secondary-container"
        >
          <span
            class="w-20 shrink-0 flex items-center justify-center font-bold text-sm px-2 break-all text-center bg-primary text-on-primary"
            title="ID"
          >
            {{ selectedItem.id ?? selectedItem.originalData?.codice }}
          </span>

          <div class="flex-1 flex items-center px-4 overflow-hidden">
            <div
              class="flex flex-wrap gap-x-4 gap-y-1 content-center w-full max-h-full overflow-hidden"
            >
              @for (prop of selectedItem.properties; track prop) {
                <div class="flex items-baseline gap-1 min-w-0 max-w-full">
                  <span
                    class="text-sm font-medium truncate"
                    [title]="prop.value"
                  >
                    {{ prop.value }}
                  </span>
                </div>
              }
            </div>
          </div>
          <div class="flex items-center px-4 shrink-">
            <button
              (click)="clearSelection()"
              [disabled]="searchControl.disabled"
              type="button"
              aria-label="Rimuovi selezione e cerca di nuovo"
              matIconButton
              matTooltip="Rimuovi selezione e cerca di nuovo"
            >
              <mat-icon class="text-[20px]! w-5! h-5! leading-none"
                >close</mat-icon
              >
            </button>
          </div>
        </div>
      </div>
    } @else {
      <div
        class="py-3 mb-3"
        [ngClass]="matCardAppearance() === 'outlined' ? 'px-3' : 'px-0'"
      >
        <mat-form-field
          class="mat-search-input col-span-2 m-h-[56px]! h-14! w-full"
          appearance="outline"
        >
          <input
            matInput
            class="text-on-surface! placeholder:text-on-surface-variant!"
            [placeholder]="placeholder()"
            [attr.aria-label]="placeholder()"
            role="searchbox"
            [formControlName]="'searchControl'"
          />
          <mat-icon matSuffix class="text-on-surface-variant">search</mat-icon>
        </mat-form-field>
      </div>

      <cdk-virtual-scroll-viewport
        [itemSize]="ITEM_SIZE"
        [style.height.px]="viewportHeight()"
        class="w-full visible-scrollbar transition-[height] duration-300 ease-in-out"
        role="listbox"
      >
        <div
          *cdkVirtualFor="let item of displayedItems()"
          class="py-2"
          [ngClass]="matCardAppearance() === 'outlined' ? 'px-4' : 'px-0'"
        >
          <div
            class="group relative flex items-stretch h-16 border rounded-lg cursor-pointer overflow-hidden transition-all duration-200 bg-surface border-none hover:shadow-md"
            role="option"
            aria-selected="false"
            tabindex="0"
            (click)="toggleSelection(item)"
            (keydown.enter)="toggleSelection(item)"
          >
            <span
              class="w-20 shrink-0 flex items-center justify-center font-bold text-sm transition-colors duration-200 px-2 break-all text-center bg-surface-variant text-on-surface-variant"
              title="ID"
            >
              {{ item.id }}
            </span>

            <div class="flex-1 flex items-center px-4 overflow-hidden">
              <div
                class="flex flex-wrap gap-x-4 gap-y-1 content-center w-full max-h-full overflow-hidden"
              >
                @for (prop of item.properties; track $index) {
                  <div class="flex items-baseline gap-1 min-w-0 max-w-full">
                    <!--     <span
                      class="text-[10px] uppercase font-bold tracking-wider shrink-0 text-on-surface-variant"
                    >
                      {{ prop.key }}:
                    </span> -->
                    <span
                      class="text-sm font-medium truncate text-on-surface"
                      [title]="prop.value"
                    >
                      {{ prop.value }}
                    </span>
                  </div>
                }
              </div>
            </div>

            <div class="flex items-center px-4 shrink-0 bg-transparent">
              <div
                class="w-6 h-6 flex items-center justify-center rounded-full transition-all duration-200"
              >
                <span
                  class="material-icons text-[16px] text-primary opacity-0 group-hover:opacity-50"
                >
                  check
                </span>
              </div>
            </div>
          </div>
        </div>
        @if (isLoading()) {
          <div class="flex flex-col justify-center items-center py-10 gap-3">
            <div class="animate-spin h-6 w-6"></div>
            <span class="text-sm font-medium text-on-surface-variant"
              >Caricamento in corso...</span
            >
          </div>
        }

        @if (!isLoading() && displayedItems().length === 0) {
          <div
            class="flex flex-col items-center justify-center h-full text-on-surface-variant"
          >
            <span class="material-icons text-4xl mb-2 opacity-50"
              >search_off</span
            >
            <span class="text-sm">Nessun risultato trovato.</span>
            @if (emptyHint()) {
              <span class="text-sm text-center mt-1 px-4">{{
                emptyHint()
              }}</span>
            }
          </div>
        }
      </cdk-virtual-scroll-viewport>

      <div
        class="px-4 py-3 bg-transparent flex justify-between items-center text-xs text-on-surface-variant shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)] z-10"
      >
        <span>
          Visualizzati
          <strong class="text-on-surface">{{ displayedItems().length }}</strong>
          elementi
        </span>
        @if (displayedItems().length > 5) {
          <span class="flex items-center gap-1 opacity-70">
            <span class="material-icons text-[14px]">arrow_downward</span>
            Scroll per altro
          </span>
        }
      </div>
    }
  </mat-card-content>
</mat-card>
